// @flow

import { isEqual } from "lodash";
import * as React from "react";
import { withRouter, useHistory } from "react-router-dom";
import queryString from "query-string";
import Tile from "../molecules/Tile";
import getContentReferenceTileProps from "../../utils/getContentReferenceTileProps";
import Pagination from "../molecules/Pagination";
import Loader from "../atoms/Loader";

const ClubProfileBody = ({ memberships, type, isLoading }): React.Node => {
    const POSTS_PER_PAGE = 12;
    const PAGINATION_WIDTH = 2;
    const history = useHistory();

    const [params, setParams] = React.useState({ page_num: 1 });

    const queryParamProps = queryString.parse(history.location.search);
    const activePage = Number(queryParamProps.page_num) || 1;
    const totalPages = Math.ceil(memberships.length / POSTS_PER_PAGE);

    if (!isEqual(queryParamProps, params)) {
        setParams(queryParamProps);
    }

    return (
        <div className="club-profile-body container-fluid">
            <div className="row">
                <div className="col-xs-12 col-md-offset-2 col-md-8">
                    <div className="row">
                        <div className="col-xs-12">
                            <div>
                                <Loader active={isLoading}>
                                    {memberships && memberships.length > 0 ? (
                                        memberships
                                            .slice(
                                                (activePage - 1) *
                                                    POSTS_PER_PAGE,
                                                POSTS_PER_PAGE * activePage
                                            )
                                            .map(membership => {
                                                const referenceContent =
                                                    getContentReferenceTileProps(
                                                        {
                                                            ...membership,
                                                            acf: {},
                                                            type: "club_membership",
                                                        }
                                                    );

                                                return (
                                                    <div
                                                        key={membership.id}
                                                        className="club-profile-body__content__row row"
                                                    >
                                                        <div className="col-md-12">
                                                            <Tile
                                                                {...referenceContent}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            })
                                    ) : (
                                        <div>
                                            You don't have any {type}
                                            {""} memberships.
                                        </div>
                                    )}
                                </Loader>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {totalPages > 1 ? (
                <div className="row">
                    <div className="col-xs-12 col-md-offset-2 col-md-8">
                        <Pagination
                            ellipsisWidth={PAGINATION_WIDTH}
                            pages={totalPages}
                            activePage={activePage}
                        />
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default withRouter(ClubProfileBody);
